/*
================================================
Une mixin pour faciliter le tracking

MIXIN SCINDÉE EN DEUX PARTIES :
  -  A. pour des évènements dans le backend via la table DataEvents
  -  B. pour des évènements via des services tiers

================================================
*/
var TrackingMixin = {

    methods: {


        ////////////////////////////////////////////////
        // 🚀 A. TRACKING VERS LE BACKEND 👇
        ////////////////////////////////////////////////
        /**
         * Enregistre un dataEvent dans le backend
         * L'envoi est asynchrone et inspiré de https://stackoverflow.com/a/50872395/666416
         * @param self
         * @param eventName Le nom de l'event (voir DataEvents dans backend)
         * @param value La valeur du DataEvent (voir DataEvents dans backend)
         * @param recordOnce si le paramètre est passé, le DataEvent sera enregistré une seule fois
         * @return {Promise<void>}
         */
        logDataEvent: async function (self, eventName, value, recordOnce) {


            try{
                const params = {}
                if(recordOnce){
                    params.record_once=null, params.name=eventName, params.value=value
                }
                else{
                  params.name=eventName, params.value=value
                }

                let response = await self.$http.post(`/organizations/${JSON.parse(this.$cookie.get('auth')).organization}/users/${JSON.parse(this.$cookie.get('auth')).userSlug}/dataEvents`,
                    params,
                    {headers: {Authorization: self.$auth.header()}}
                )

            }catch(error) {
            }
        },

        /*
            Détecte si l'app est utilisé en mode standalone (pwa instalée)
            https://stackoverflow.com/a/41749865/666416
         */
        pwaIsStandalone: function (){
            const mqStandAlone = '(display-mode: standalone)';

            if (navigator.standalone || window.matchMedia(mqStandAlone).matches) {
                return true
            }
        },

        ////////////////////////////////////////////////
        // 🚀 B. TRACKING VERS DES SERVICES TIERS 👇
        ////////////////////////////////////////////////
        /**
         * Track les affichages des tooltips dans mixpanel et google analytics
         * @param string (identifiant de la tooltip)
         * */
        trackTooltip: function (tooltipId){
            // tracking
            let msg = 'Tootlip displayed'
            this.$mixpanel.track(msg, {"tooltip":tooltipId});
            this.$gtag.event(msg, { event_category: 'Project', event_label: msg,value:tooltipId })
        },

        /**
         * Méthode de tracking globale pour Google Analytics
         * @param eventName {string} Le nom à donner à l'event envoyé vers Google Analytics
         * @param details {Object} Un objet custom à passer avec l'evénement
         */
        ga4GlobalEventTrack: function (eventName, details){

            details.appVersion = process.env.VUE_APP_VERSION;
            this.$gtag.event(eventName, details)

        }


    }



}

export default TrackingMixin;
